import { useEffect, useState } from 'react';
import { OperationsPage } from '../admin/OperationsPage';
import { DashboardPage } from './DashboardPage';
import type { DashboardCache } from './use-dashboard-refresh';
import type { DashboardSummary } from './dashboard-api';
import type { OperationsDashboardSnapshot } from '@tcvs/shared';

const ROTATION_INTERVAL_MS = 60_000;

type WallboardView = 'sales' | 'operations';

export function WallboardPage(): JSX.Element {
  const [view, setView] = useState<WallboardView>('sales');
  const [caches] = useState(() => ({
    sales: {} as DashboardCache<DashboardSummary>,
    operations: {} as DashboardCache<OperationsDashboardSnapshot>,
  }));

  useEffect(() => {
    const interval = window.setInterval(
      () => setView((current) => (current === 'sales' ? 'operations' : 'sales')),
      ROTATION_INTERVAL_MS,
    );
    return () => window.clearInterval(interval);
  }, []);

  return (
    <div className="tcvs-rotating-wallboard">
      <nav className="tcvs-wallboard-switcher" aria-label="Wallboard view">
        <button type="button" aria-pressed={view === 'sales'} onClick={() => setView('sales')}>
          Sales
        </button>
        <button
          type="button"
          aria-pressed={view === 'operations'}
          onClick={() => setView('operations')}
        >
          System operations
        </button>
      </nav>
      {view === 'sales' ? (
        <DashboardPage key="sales" embeddedWallboard refreshCache={caches.sales} />
      ) : (
        <OperationsPage key="operations" embeddedWallboard refreshCache={caches.operations} />
      )}
    </div>
  );
}
